import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Driver } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { Driver as DOTSDriver, DriverService } from '@uzurv/dots';

@Component({
  selector: 'app-ignored-drivers-list-item',
  templateUrl: './ignored-drivers-list-item.component.html',
  styleUrls: ['./ignored-drivers-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IgnoredDriversListItemComponent implements OnChanges {
  @Input()
  driver: Driver;

  @Output()
  deleteDriver: EventEmitter<Driver> = new EventEmitter();

  dotsDriver: DOTSDriver;

  constructor(private driverService: DriverService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['driver']) {
      this.dotsDriver = isNullOrUndefined(this.driver) ? null : this.driverService.buildDotsDriverFromClaraDriver(this.driver);
    }
  }

  deleteIgnoredDriver(event: any): void {
    this.deleteDriver.emit(this.driver);
  }
}
